import React from 'react';
import '../styles/TalkExpertSection.css';

const TalkExpertSection = () => (
  <div className="talk-expert-section">
    <h2>Need Guidance?</h2>
    <p>Talk to an expert for personalized advice on Dubai real estate investment.</p>
    <a href="/contact" className="talk-expert-btn">Talk to an Expert</a>
  </div>
);

export default TalkExpertSection; 